import { getAPIData, getAPIDataParams, postApi } from 'app/utils/apiFunction';
import React from 'react';
import { userInfo, RequestGraphData } from '../../../adalConfig';
import { Card, CircularProgress, IconButton, Typography } from '@mui/material';

import FridgeNotifications from './Notifications/FridgeNotification';
import ReceivalReadyNotifications from './Notifications/ReceivalReady';
import { reload } from 'firebase/auth';






const NotifcationFuncList = [
    { "Id": 1, "Name": "Fridges", "Function": FridgeNotifications },
    { "Id": 2, "Name": "Receivals Ready To Be Released", "Function": ReceivalReadyNotifications },
]

const Notifications = (props) => {
    const [notifications, setNotifications] = React.useState(null);
    const [notificationFunctions, setNotificationFunctions] = React.useState(null);
    const [user, setUser] = React.useState(userInfo());
    const [userSMS, setUserSMS] = React.useState(null);
    const [teamsChats, setTeamsChats] = React.useState([]);
    const [reload, setReload] = React.useState(false);
    React.useEffect(() => {
        RequestGraphData('https://graph.microsoft.com/v1.0/me', null)
            .then(async (response) => {
                var data = await response.json();
                if (response.status === 200) {
                    setUserSMS(data.mobilePhone);
                }
            })
            .catch((error) => {
                console.log('error', error);
            });
        RequestGraphData('https://graph.microsoft.com/v1.0/me/chats', null)
            .then(async (response) => {
                var data = await response.json();
                if (response.status === 200) {
                    var chats = data.value.filter((c) => {
                        return c.chatType === 'group'
                    });
                    setTeamsChats(chats);
                }
            })
            .catch((error) => {
                console.log('error', error);
            });
    }, []);
    React.useEffect(() => {
        getAPIData('/Notifications/GetTypes', setNotificationFunctions);

    }, []);
    React.useEffect(() => {
        const organiseNotifications = (nots) => {
            setNotifications(nots?.map((n) => {
                n.mobileBool = ((n.mobile === "") || (n.mobile === null)) ? false : true;
                n.emailBool = ((n.user === "") || (n.user === null)) ? false : true;
                return n;
            }));
        }

        if (user) {
            getAPIDataParams('/Notifications/Get', organiseNotifications, { Owner: user.userName });
        }
    }, [user,reload]);
    const submit = async (oldNotifications, newNotifications) => {
        //notifications to add and update
        var prmArr = [];
        for (var i = 0; i < newNotifications.length; i++) {
            var n = newNotifications[i];
            n.owner = user.userName;
            n.mobile = n.mobileBool ? userSMS : null;
            n.user = n.emailBool ? user.userName : null;
            var delList = [];
            for (var j = 0; j < Object.keys(n).length; j++) {
                if (n[Object.keys(n)[j]] === null || n[Object.keys(n)[j]] === undefined) {
                    delList.push(Object.keys(n)[j]);
                }
            }
            for (var j = 0; j < delList.length; j++) {
                delete n[delList[j]];
            }
            //update
            prmArr.push(postApi('/Notifications/Save', {
                ...n
            }).then((res) => {
            }));

        }
        //notifications to delete
        for (var i = 0; i < oldNotifications.length; i++) {
            var n = oldNotifications[i];
            if (!newNotifications.find(n2 => n2.id === n.id)) {
                //delete
                prmArr.push(postApi('/Notifications/Delete', {
                    ...n
                }).then((res) => {
                    console.log('res', res);
                }));
            }
        }
        //wait for all promises to finish
        await Promise.all(prmArr).then((res) => {
            setReload(!reload);
        });
        return true;

    }

    return (
        <div >
            <Typography variant='h2'>Notifications (Email: {user.userName}, SMS: {userSMS})</Typography>
            {notificationFunctions && notifications ? notificationFunctions.map((nf, index) => {
                const NotificationFunc = NotifcationFuncList.find(n => n.Id === nf.id);
                if (!NotificationFunc) return null;
                return (
                    <Card key={index} style={{ padding: '20px', margin: '20px' }}>
                        <Typography variant='h3'>{NotificationFunc.Name}</Typography>
                        <NotificationFunc.Function access={props.access} notifications={notifications.filter(n => n.functionId === nf.id)} functionId={nf.id} submit={submit} user={user.userName} mobile={userSMS} teamsChats={teamsChats} />
                    </Card>
                );
            }) : (
                <CircularProgress />
            )}
        </div>
    );
};



export default Notifications;
